import { config } from '../../utilities/config';
import keycloak from '../../keycloak';

export async function fetchDataControlsApi(organizationId, entityId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/entity/${entityId}/data-control` , {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    }
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

export async function createDataControlApi(organizationId, entityId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/entity/${entityId}/data-control`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function editDataControlApi(organizationId, entityId, dataControlId, data) {
  const response = await fetch(
    `${config.API_BASE_URL}/${organizationId}/entity/${entityId}/data-control/${dataControlId}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`
      },
      body: JSON.stringify(data)
    }
  );
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function removeDataControlApi(organizationId, entityId, dataControlId) {
  const response = await fetch(
    `${config.API_BASE_URL}/${organizationId}/entity/${entityId}/data-control/${dataControlId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`
      }
    }
  );
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}
